<div class="catalog_block">
  <div class="tablet_menu_items">
    <div class="tablet_menu_items--item pointer"
         *ngFor="let elem of menuItemsForTablet"
         (click)="navigate.emit(elem.route)"
    >
      <img [src]="'assets/images/icons/navbar/catalog/' + elem.img + '.png'">
      <div class="icon_name">
        {{elem.text | translate}}
      </div>
    </div>
  </div>
  <div class="container w_h flex_between_align_center">
    <div class="flex h_100">
      <div class="catalog_block--products">
        <div class="catalog_block--products--item pointer flex_between_align_center"
             (mouseenter)="selectedProduct = i"
             [ngClass]="{active_product: i === selectedProduct }"
             (click)="selectedProduct = i"
             *ngFor="let section of sections, let i = index">
          <div class="flex_align_center">
            <img class="secondaryImage" [src]="section.secondaryImageUrl">
            <div class="text">{{section.name}}</div>
          </div>
          <img src="assets/images/icons/navbar/arrow_left_icon.svg">
        </div>
      </div>
      <div class="catalog_block--selected_products" *ngIf="sections?.length">
        <div class="catalog_block--selected_products--title">
          {{sections[selectedProduct].name}}
        </div>
        <div class="catalog_block--selected_products--content">
          <div class="name pointer" *ngFor="let item of sections[selectedProduct].categories"
            (click)="openSectionPage(sections[selectedProduct], item)"
          >
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
    <div class="catalog_block--application">
      <div class="catalog_block--application--block">
        <div class="catalog_block--application--block--title">
          <div class="top">
            {{'catalog.flowers_in_your_phone' | translate}}
          </div>
          <div class="bottom">
            {{'catalog.download_our_app' | translate}}
          </div>
        </div>
        <div class="catalog_block--application--block--icons">
          <img class="qr_code_icon" src="assets/images/icons/footer/qr-code.png">
          <div class="ml_12 app_images">
            <div class="flex_align_center store_icon">
              <img src="assets/images/icons/navbar/catalog/iphone_logo.svg">
              <img class="ml_12 name_icon" src="assets/images/icons/navbar/catalog/app_store_text.svg">
            </div>
            <div class="flex_align_center store_icon mt_12">
              <img src="assets/images/icons/navbar/catalog/play_market_logo.svg">
              <img class="ml_12 name_icon" src="assets/images/icons/navbar/catalog/google_play_text.svg">
            </div>
          </div>
        </div>
        <img class="smart_photo" src="assets/images/icons/navbar/catalog/smart_photo.png">
      </div>
    </div>
  </div>
</div>
